export default {
    QUESTION: 'Type label or question here',
    ANSWER: 'Type your answer',
    HELP: 'Add description or help text',
    ADD_CHOICE: 'Add choice',
    CHOICE_TEXT: 'Choice text',
    CHOICE_POINT: 'Choice point',
    DELETE_CHOICE: 'Remove choice',
    HEADER_TITLE: 'Type header title here',
    MAX_POINT: 'Target Point',
    ASSESS_POINT: 'Earned Point',
    QUESTIONS: 'Questions',
    ANSWERS: 'Answers',
    REQUIRED: 'Required',
    UP: 'Up',
    DOWN: 'Down',
    DELETE: 'Delete',
    DELETE_CONFIRM: 'Are you sure?',
    PREVIEW: 'Preview',
    EDIT: 'Edit',
    SUBMIT: 'Submit',
    SAVE: 'Save',
    NONE: 'None',
    DATA_INCOMPLETE: 'Data is incomplete. Please, check again!',
    DATA_SUBMITTED: 'Data is successfully submitted!',
    CLEAR: 'Clear',
    CLEAR_CONFIRM: 'Are you sure clearing all components?',
    CORRECT_ANSWER: '<div><u>Correct Answer</u></div>',
    CONTAINER_WARNING: 'Container element does not exist!'    
}